<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <specific-health-exam-table
      :board="board"
      :is-print="isPrint"
      title="특수건강진단 현황"
      :tableData="[
        { id: 'input1', title: '부서명', type: 'text', default: form.stdInfo.com_name, readonly: true },
        { id: 'input2', title: '이름', type: 'text', placeholder: '입력' },
        {
          id: 'input3',
          title: '수검 여부',
          type: 'radio',
          selectData: ['수검', '미수검'],
          default: '미수검',
        },
        { id: 'input5', title: '주기', type: 'text', placeholder: '입력' },
        { id: 'input4', title: '미수검 사유', type: 'text', placeholder: '입력', visible: { input3: '미수검' } },
      ]"
      :use주기="true"
      v-model="form.exam"
      @input="handleList"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="file_1" class="w-full mt-4" v-model="form.fileList1" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <specific-health-exam-table
      :board="board"
      :is-print="isPrint"
      title="배치전건강진단 현황"
      :tableData="[
        { id: 'input1', title: '부서명', type: 'text', default: form.stdInfo.com_name, readonly: true },
        { id: 'input2', title: '이름', type: 'text', placeholder: '입력' },
        {
          id: 'input3',
          title: '수검 여부',
          type: 'radio',
          selectData: ['수검', '미수검'],
          default: '미수검',
        },
        { id: 'input4', title: '미수검 사유', type: 'text', placeholder: '입력', visible: { input3: '미수검' } },
      ]"
      v-model="form.배치전건강진단"
      @input="handleList"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="file_2" class="w-full mt-4" v-model="form.fileList2" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <specific-health-exam-table
      :board="board"
      :is-print="isPrint"
      title="배치후건강진단 현황"
      :tableData="[
        { id: 'input1', title: '부서명', type: 'text', default: form.stdInfo.com_name, readonly: true },
        { id: 'input2', title: '이름', type: 'text', placeholder: '입력' },
        {
          id: 'input3',
          title: '수검 여부',
          type: 'radio',
          selectData: ['수검', '미수검'],
          default: '미수검',
        },
        { id: 'input4', title: '미수검 사유', type: 'text', placeholder: '입력', visible: { input3: '미수검' } },
      ]"
      v-model="form.배치후건강진단"
      @input="handleList"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="file_3" class="w-full mt-4" v-model="form.fileList3" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import SpecificHealthExamTable from "@/components/SpecificHealthExamTable";
import PopupExcelDownload from "@/popup/PopupExcelDownload";

export default {
  components: {
    PopupExcelDownload,
    SpecificHealthExamTable,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList1: [],
        fileList2: [],
        fileList3: [],
        exam: [],
        배치전건강진단: [],
        배치후건강진단: [],
        countTotal: 0,
        countChecked: 0,
        percentChecked: 0,
      },
    };
  },
  methods: {
    handleList(data) {
      this.form.countTotal = data.length;
      if (this.form.countTotal === 0) {
        this.form.countChecked = 0;
        this.form.percentChecked = 0;
        return;
      }

      let countChecked = 0;
      for (const row of data) {
        let checkedStatus = "미수검";
        if (typeof row.input3 === "undefined") {
          checkedStatus = "미수검";
        } else {
          const split = row.input3.split("|");
          if (split.length > 1) {
            checkedStatus = split[1];
          } else {
            checkedStatus = "미수검";
          }
        }

        if (checkedStatus === "수검") {
          countChecked += 1;
        }
      }
      this.form.countChekced = countChecked;

      const percent = Math.round((this.form.countChekced * 10000) / this.form.countTotal) / 100;
      if (isNaN(percent)) {
        this.form.percentChecked = 0;
      } else {
        this.form.percentChecked = percent;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
